'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 40px;\n  height: 40px;\n\n  margin: 0;\n  padding: 0;\n\n  color: ', ';\n  font-size: 32px;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  cursor: pointer;\n'], ['\n  width: 40px;\n  height: 40px;\n\n  margin: 0;\n  padding: 0;\n\n  color: ', ';\n  font-size: 32px;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  cursor: pointer;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icon = require('../../models/icon');

var _icon2 = _interopRequireDefault(_icon);

var _variables = require('../../styles/variables');

var _variables2 = _interopRequireDefault(_variables);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledButton = _styledComponents2.default.button(_templateObject, _variables2.default.BLACK);

var Button = function Button(_ref) {
  var defaultIcon = _ref.defaultIcon,
      icon = _ref.icon,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    StyledButton,
    {
      className: 'ignore-react-onclickoutside',
      onClick: onClick
    },
    icon ? icon.render() : defaultIcon.render()
  );
};

Button.propTypes = {
  defaultIcon: _icon2.default.isRequired,
  icon: _icon2.default,
  onClick: _propTypes2.default.func
};

Button.defaultProps = {
  icon: {
    name: 'placeholder',
    render: '🚀'
  },
  onClick: function onClick() {}
};

exports.default = Button;